import { Palette } from "@mui/material/styles";
import { Event } from "@helpers/charts/mergeCloseByDate";

export const getEventLabel = (event: Event, colors: Palette) => {
  switch (event.type) {
    case "expected_dividend":
    case "dividend":
    case "retained_dividend":
      return { name: "D", color: colors?.success.dark };
    case "buy":
    case "book_in":
      return { name: "K", color: colors?.primary.main };
    case "sell":
    case "book_out":
      return { name: "V", color: colors?.error.dark };
    case "carve_out":
      return { name: "C", color: colors?.error.dark };
    case "purchase_right":
      return { name: "B", color: colors?.error.dark };
    case "split":
      return { name: "SP", color: colors?.primary.dark };
    default:
      return { name: "unknown", color: colors?.common.black };
  }
};

export const getEventLabelForEvents = (events: Event[], colors: Palette) => {
  if (events.length > 1) {
    return { name: events.length.toString(), color: colors.text.secondary };
  }
  const event = events[0];

  return getEventLabel(event, colors);
};
